var $resultsElement = $('#product-results');
var activeViewType = getLayoutType();
var layoutCookieName = $resultsElement.attr('data-layout-cookie-name');

$(function() {
    $('.list-view-btn').on('click', function(e) {
        var prevViewType = activeViewType;
        activeViewType = $(this).data('view');

        // If the view types are different, update them
        if (prevViewType != activeViewType) {
            // Remove previous active class
            $resultsElement.removeClass('product-' + prevViewType);
            $resultsElement.find('section[data-hide-on-viewtype="' + prevViewType   + '"]').removeClass('d-none');
            $resultsElement.find('section[data-hide-on-viewtype="' + activeViewType + '"]').addClass('d-none');

            $('.list-view-btn').removeClass('active'); // Deactivate all list view buttons
            $(this).addClass('active');

            // Update layout.
            saveViewLayout();
        }
    });

    // Listener for show more/less on description
    $( '.window-shade .show' ).click(function(e) {
        var product_id = $(e.target).closest('.window-shade').data('product-id');
        
        // keep from losing place in page when expanding/collapsing large descriptions
        var offset = $('#saved-item-' + product_id).offset().top;
        var banner = $('body > header').css('position') == 'sticky' ? $('body > header').height() : 0;
        $('html, body').animate(
            {
              scrollTop: offset - banner,
            },
            250,
            'linear'
        );
        
        $('section.short-description[data-product-id=\'' + product_id + '\']').toggleClass('truncate');
    });
    
    checkMobileLayout();
});

$(window).on('resize', function() {
    checkMobileLayout();
});

function getGridClassName() {
    return 'product-' + activeViewType;
}

function getLayoutType() {
    return $resultsElement.hasClass('product-grid') ? 'grid' : 'list';
}

function saveViewLayout() {
    $resultsElement.addClass(getGridClassName());

    if ( layoutCookieName ) {
        this.setCookie(layoutCookieName, activeViewType, 30, '/');
    }
}

function checkMobileLayout() {
    var width = $(window).width();

    // If on mobile, put layout in list view.
    if (width < 768) {
        // Trigger list button on click event.
        $('.list-view-btn[data-view="list"]').trigger('click');
    }
}
